import {
    EventsExtraData,
    iMetricProtocol,
    InitialValue,
    ProtocolType,
    RuntimeEventData,
} from '../types';
import { iPoolMember } from '@/app/tools/utility_interfaces';
import ValueHolder from './ValueHolder';
import { deepSerializationCopy } from '@/app/tools/objectUtils';

/**
 * Предок всех протоколов отправки метрик
 */
export default abstract class AbstractMetricProtocol
    implements iMetricProtocol, iPoolMember {
    protected value: InitialValue;
    protected extraEventData: EventsExtraData = {};

    constructor(protected readonly type: ProtocolType) {}

    public getType(): ProtocolType {
        return this.type;
    }

    public abstract send(): void;

    public release() {
        this.value = undefined;
    }

    public setValue(eventInfo: InitialValue, customValue?: RuntimeEventData) {
        if (eventInfo instanceof ValueHolder) {
            eventInfo._setRuntimeValue(customValue);
            eventInfo = eventInfo._getValue();
        }

        this.value = eventInfo;

        return typeof this.value === 'object'
            ? deepSerializationCopy(this.value)
            : this.value;
    }

    public addExtraData(extraData: EventsExtraData) {
        Object.assign(this.extraEventData, extraData);
    }
}
